import { render, staticRenderFns } from "./payroll-setup.vue?vue&type=template&id=e3b44a70"
import script from "./payroll-setup.vue?vue&type=script&lang=js"
export * from "./payroll-setup.vue?vue&type=script&lang=js"
import style0 from "./payroll-setup.vue?vue&type=style&index=0&id=e3b44a70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports